import { INITIALIZE_FORM } from '../actionTypes';
import { createTemplateModalActions } from '../reducer';

export default (values) => createTemplateModalActions[INITIALIZE_FORM](values);
